module.exports = __webpack_public_path__ + "img/logo_lekarne.52dbdab1.svg";